import { Pipe, PipeTransform } from '@angular/core';
import { DomainTerminologyTranslationService } from 'app/core/domain-terminology/domain-terminology-translation.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translateTerminology',
})
export class TranslateTerminologyPipe implements PipeTransform {
  protected onChanges: Subscription;

  constructor(private translation: DomainTerminologyTranslationService) {
  }

  public transform(key: string, params?: any): string | null {
    if (key == null || key === '') return null;

    return this.translation.translate(key, params);
  }
}
